import { render, staticRenderFns } from "./InfoBar.vue?vue&type=template&id=c757acce&scoped=true&"
import script from "./InfoBar.vue?vue&type=script&lang=js&"
export * from "./InfoBar.vue?vue&type=script&lang=js&"
import style0 from "./InfoBar.vue?vue&type=style&index=0&id=c757acce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c757acce",
  null
  
)

export default component.exports